<template>
  <v-card>
    <v-card-title class="text-h6">
      Solicitud de oposición — {{ request.treatmentPurpose }}
    </v-card-title>
    <v-divider />

    <v-card-text class="pt-4">
      <div class="mb-4">
        <div><strong>Estado:</strong> {{ request.status }}</div>
        <div><strong>Base legal:</strong> {{ request.legalBasis }}</div>
        <div><strong>Recibida:</strong> {{ request.receivedAt | date }}</div>
        <div><strong>Plazo:</strong> {{ (request.extendedDeadlineAt || request.deadlineAt) | date }}</div>
        <div v-if="request.decisionReason">
          <strong>Motivo de la decisión:</strong> {{ request.decisionReason }}
        </div>
      </div>

      <v-divider class="mb-4" />

      <div v-if="isPendingReview">
        <h4 class="mb-2">Decisión</h4>
        <v-radio-group v-model="decision" row hide-details>
          <v-radio label="Aceptar" value="accepted" />
          <v-radio label="Rechazar" value="rejected" />
        </v-radio-group>
        <v-textarea
          v-if="decision === 'rejected'"
          v-model="decisionReasonInput"
          label="Motivo del rechazo"
          outlined
          dense
          rows="3"
          hide-details
          class="mb-2"
        />
        <v-btn
          color="primary"
          class="mt-2"
          :loading="submittingDecision"
          :disabled="!canConfirmDecision"
          @click="submitDecision"
        >
          Confirmar decisión
        </v-btn>
      </div>

      <v-divider v-if="request.blockRequested" class="my-4" />

      <div v-if="request.blockRequested">
        <h4 class="mb-2">Pedido de bloqueo</h4>
        <div class="mb-2"><strong>Estado del bloqueo:</strong> {{ request.blockStatus }}</div>

        <template v-if="isBlockPending">
          <v-radio-group v-model="blockDecision" row hide-details>
            <v-radio label="Aceptar bloqueo" value="accepted" />
            <v-radio label="Rechazar bloqueo" value="rejected" />
          </v-radio-group>
          <v-textarea
            v-model="blockDecisionReasonInput"
            label="Motivo (opcional)"
            outlined
            dense
            rows="2"
            hide-details
            class="mb-2"
          />
          <v-btn
            color="primary"
            class="mt-2"
            :loading="submittingBlockDecision"
            :disabled="!blockDecision"
            @click="submitBlockDecision"
          >
            Confirmar decisión de bloqueo
          </v-btn>
        </template>

        <div v-else-if="request.blockDecisionReason">
          <strong>Motivo:</strong> {{ request.blockDecisionReason }}
        </div>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn text @click="$emit('close')">Cerrar</v-btn>
    </v-card-actions>

    <v-snackbar v-model="showSnackbar" :color="snackbarColor" timeout="4000" top>
      {{ snackbarMessage }}
    </v-snackbar>
  </v-card>
</template>

<script>
import OppositionRequestsService from '@/services/opposition-requests.service';
import { utilsMixin } from '@/mixins/utilsMixin';
import { OPPOSITION_REQUEST_STATUS, BLOCK_STATUS } from '@/utils/constants';

export default {
  name: 'OppositionRequestReviewModal',
  mixins: [utilsMixin],

  props: {
    request: { type: Object, required: true }
  },

  data() {
    return {
      decision: null,
      decisionReasonInput: '',
      submittingDecision: false,
      blockDecision: null,
      blockDecisionReasonInput: '',
      submittingBlockDecision: false,
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: 'green'
    };
  },

  computed: {
    isPendingReview() {
      return this.request.status === OPPOSITION_REQUEST_STATUS.PENDING_MANUAL_REVIEW;
    },

    isBlockPending() {
      return this.request.blockStatus === BLOCK_STATUS.PENDING;
    },

    canConfirmDecision() {
      if (!this.decision) return false;
      if (this.decision === 'rejected') return this.decisionReasonInput.trim().length > 0;
      return true;
    }
  },

  methods: {
    async submitDecision() {
      this.submittingDecision = true;
      const reason = this.decision === 'rejected' ? this.decisionReasonInput.trim() : undefined;
      const res = await OppositionRequestsService.review(this.request.id, this.decision, reason);
      this.submittingDecision = false;
      if (res.status === 'ok') {
        this.$emit('resolved', res.data);
      } else {
        this.showErrorSnackbar(res.message || 'No se pudo registrar la decisión.');
      }
    },

    async submitBlockDecision() {
      this.submittingBlockDecision = true;
      const reason = this.blockDecisionReasonInput.trim() || undefined;
      const res = await OppositionRequestsService.blockReview(this.request.id, this.blockDecision, reason);
      this.submittingBlockDecision = false;
      if (res.status === 'ok') {
        this.$emit('resolved', res.data);
      } else {
        this.showErrorSnackbar(res.message || 'No se pudo registrar la decisión de bloqueo.');
      }
    }
  }
};
</script>
